import React, { useState, useEffect } from "react";
import { Layout, Dropdown, Avatar, Select, Space } from "antd";
import { useTranslation } from "react-i18next";
import {
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import Sidebar from "../Sidebar/Sidebar";
import "../Styles/AppLayout.css";

const { Header, Content } = Layout;

const SIDEBAR_COLLAPSED_KEY = "velan_sidebar_collapsed";

const AppLayout = ({ children, cartCount }) => {
  const { t, i18n } = useTranslation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return saved === "true";
  });

  const handleSidebarCollapse = (collapsed) => {
    setSidebarCollapsed(collapsed);
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLanguage") || "ku";
    if (savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
    if (i18n.languages?.includes("en")) {
      i18n.languages = i18n.languages.filter((l) => l !== "en");
    }
  }, []);

  const languageOptions = [
    { value: "ku", label: "کوردی" },
    { value: "ar", label: "العربية" },
  ];

  const profileMenuItems = [
    {
      key: "language",
      label: (
        <div style={{ padding: "4px 0" }} onClick={(e) => e.stopPropagation()}>
          <Select
            value={i18n.language === "en" ? "ku" : i18n.language}
            onChange={(lng) => {
              i18n.changeLanguage(lng);
              localStorage.setItem("selectedLanguage", lng);
              localStorage.setItem("i18nextLng", lng);
            }}
            options={languageOptions}
            style={{ width: "100%", minWidth: 120 }}
            bordered={false}
            size="middle"
          />
        </div>
      ),
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined style={{ color: "#ff4d4f" }} />,
      label: t("logout"),
      onClick: () => {
        localStorage.removeItem("sessionToken");
        window.location.href = "/";
      },
    },
  ];

  return (
    <Layout className="app-layout">
      <Sidebar
        collapsed={sidebarCollapsed}
        onCollapse={handleSidebarCollapse}
        cartCount={cartCount}
      />
      <Layout className="main-layout">
        <Header className="app-header">
          <button
            type="button"
            className="sidebar-trigger"
            onClick={() => handleSidebarCollapse(!sidebarCollapsed)}
            aria-label={sidebarCollapsed ? "Expand menu" : "Collapse menu"}
          >
            {sidebarCollapsed ? (
              <MenuUnfoldOutlined className="trigger-icon" />
            ) : (
              <MenuFoldOutlined className="trigger-icon" />
            )}
          </button>
          <div className="header-actions">
            <a href="/CartShop" className="header-cart">
              <ShoppingCartOutlined className="header-icon" />
              {cartCount > 0 && (
                <span className="cart-badge">{cartCount}</span>
              )}
            </a>
            <Dropdown menu={{ items: profileMenuItems }} trigger={["click"]} placement="bottomRight">
              <Space className="header-profile" style={{ cursor: "pointer" }}>
                <Avatar
                  icon={<UserOutlined />}
                  className="header-avatar"
                />
                <span className="header-profile-text">{t("profile")}</span>
              </Space>
            </Dropdown>
          </div>
        </Header>
        <Content className="app-content">{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
